import React from 'react'
import { useTranslation } from 'react-i18next'

export default function Error404() {
    const { t } = useTranslation()
    return (
        <React.Fragment>
            <div className="single-error">
                <p>{t('notFound.message')}</p>
            </div>
        </React.Fragment>
    )
}
